<!-- Logic for all states of passes -->
<ng-container *ngIf="loaded; else loadingTpl">
  <ng-container *ngIf="!error; else errorTpl">
    <ng-container *ngIf="passes?.length; else emptyTpl">
      <ng-container *ngTemplateOutlet="passList"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<!-- template for loading passes -->
<ng-template #loadingTpl>
  <div class="loading">
    <!-- Mobile Loading Placeholder -->
    <fz-skeleton
      viewBox="0 0 245 125"
      viewBox="0 0 768 900"
      class="loading__mobile"
    >
      <svg:rect x="0" y="9" rx="8" ry="8" width="140" height="24" />
      <svg:rect x="0" y="46" rx="8" ry="8" width="667" height="24" />
      <svg:rect x="0" y="86" rx="12" ry="12" width="98%" height="311" />
      <svg:rect x="0" y="412" rx="12" ry="12" width="98%" height="311" />
    </fz-skeleton>

    <!-- Tablet and Desktop Loading Placeholder -->
    <fz-skeleton
      viewBox="0 0 245 125"
      viewBox="0 0 1000 300"
      class="loading__tablet loading__desktop"
    >
      <svg:rect x="0" y="9" rx="8" ry="8" width="140" height="12" />
      <svg:rect x="0" y="36" rx="8" ry="8" width="667" height="12" />
      <svg:rect x="0" y="72" rx="12" ry="12" width="49%" height="211" />
      <svg:rect x="51%" y="72" rx="12" ry="12" width="49%" height="211" />
    </fz-skeleton>
  </div>
</ng-template>

<!-- template for empty passes -->
<ng-template #emptyTpl>
  <div class="empty-list">
    <!-- For this case never show passes -->
  </div>
</ng-template>

<!-- template for error -->
<ng-template #errorTpl>
  <div class="error">Error</div>
</ng-template>

<!-- template for passes -->
<ng-template #passList>
  <div class="tournament-pass-list">
    <div
      *ngFor="let pass of passes; trackBy: trackByPassIdentifier"
      [@slideInRight]
      class="tournament-pass-list__item"
      [@slideInRight]
    >
      <fz-pass-card
        [pass]="pass"
        [tournamentEntryFee]="tournamentEntryFee"
        (press)="passPressed.emit(pass)"
        (share)="onSharePass(pass)"
      ></fz-pass-card>
    </div>
  </div>
</ng-template>
